import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ContactForm from '../contact-form/ContactForm';
import "./Footer.css";

function Footer() {
    const { t } = useTranslation();
    return (
        <>
            <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_SITE_KEY || ""}
                scriptProps={{
                    async: true,
                    defer: true,
                    appendTo: 'head'
                }}>
                <div className="footer-links">
                    <ContactForm />
                    <Link to="/mentions-legales">{t("footer.gtcu")}</Link>
                    <Link to="/charte-donnees-personnelles">{t("footer.siteMap")}</Link>
                </div>
                <span>&copy; 2022 TotalEnergies</span>
            </GoogleReCaptchaProvider>
        </>
    )
}

export default Footer;